import { render, staticRenderFns } from "./XhExpenses.vue?vue&type=template&id=06f9c7fc&scoped=true"
import script from "./XhExpenses.vue?vue&type=script&lang=js"
export * from "./XhExpenses.vue?vue&type=script&lang=js"
import style0 from "./XhExpenses.vue?vue&type=style&index=0&id=06f9c7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9c7fc",
  null
  
)

export default component.exports